import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const AppRoute = ({
  component: Component,
  layout: Layout,
  requireAuth = false,
  ...rest
}) => {
  const { token } = useContext(AuthContext);

  Layout = (Layout === undefined) ? props => (<React.Fragment>{props.children}</React.Fragment>) : Layout;

  return (
    <Route
      {...rest}
      render={props => {
        if (requireAuth && !token) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: `${props.location.pathname}${props.location.search}${props.location.hash}` }
              }}
            />
          );
        }

        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      }} />
  );
}

export default AppRoute;